/* eslint-disable */
import ajax from '@/utils/request'
import Vue from 'vue'
import utils from 'gkSrc/utils'
import localStorage, {canUsed} from 'gkSrc/utils/local.storage'
import {
  login as appLogin
} from '@geekbang/time.sdk'
import cookie from './cookie'
import store from '../store'
import state from '../store/state'
import * as types from '../store/mutations-type'

export default {
  ...utils,
  storage: {
    get: (key) => {
      let storageCache = localStorage.get(key)
      return storageCache
    },
    set: (key, value) => {
      localStorage.set(key, value)
      cookie.set(key, value)
    },
    remove (key) {
      localStorage.remove(key)
      cookie.remove(key)
    }
  },
  /**
   * 刷新登录态
   */
  refreshLoginStatus () {
    return new Promise((resolve, reject) => {
      store.dispatch('getSigninInfo').then((res) => {
        // if (res.uid) {
        //   store.dispatch('getUserInfo')
        // }
        // 获取缓存中未执行的需要登录后的操作
        const loginAction = this.storage.get('loginAction')
        const pageAction = this.storage.get('pageAction')
        this.storage.remove('loginAction')
        this.storage.remove('pageAction')

        if (loginAction && loginAction.options) {
          ajax(loginAction.options).then((res) => {
            Vue.prototype.$EventBus.$emit('INFOQ_LOGIN_SUCCESS')

            if (pageAction && pageAction.options) {
              Object.assign(pageAction.options, res)
              store.commit(types.SET_PAGE_ACTION, pageAction.options)
            }
            resolve()
          }).catch((err) => {
            if (pageAction && pageAction.options) {
              store.commit(types.SET_PAGE_ACTION, err)
            }
            Vue.prototype.$EventBus.$emit('INFOQ_LOGIN_SUCCESS')
            resolve()
          })
        } else {
          Vue.prototype.$EventBus.$emit('INFOQ_LOGIN_SUCCESS')
          resolve()
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * 跳转登录
   * @param {Object} params 链接上的参数
   * @param {Bollean} showModal  是否当前窗口弹窗登录
   */
  login (params, showModal = true) {
    if (this.isInApp()) {
      appLogin()
    } else if (showModal && !this.isInWeixin()) {
      Vue.prototype.$login.showLogin({
        success: () => {
          if (params && params.cb) {
            return new Promise(resolve => {
              store.dispatch('getSigninInfo')
              params.cb()
              resolve()
            })
          } else {
            return this.refreshLoginStatus()
          }
        }
      })

      return
    }

    let redirect = window.location.href
    if (params) {
      Object.keys(params).map(key => {
        redirect = this.addUrlParam(redirect, key, params[key])
      })
    }

    if (!this.isInApp()) {
      window.location.href = state.loginDomain !== 'biz'
        ? 'https://account.geekbang.org/infoq/login?redirect=' + encodeURIComponent(redirect)
        : 'https://account.geekbang.org/biz/signin?redirect=' + encodeURIComponent(redirect)
    }

    // if (this.isInApp()) {
      // Vue.prototype.$timesdk.login()

      // loopLoginStatusTimer = setInterval(() => {
      //   if (!commonAppHeaders) {
      //     commonAppHeaders = Vue.prototype.$timesdk.getCommonHeaders()
      //   } else {
      //     Vue.prototype.$EventBus.$emit('getCommonHeaders')
      //     clearInterval(loopLoginStatusTimer)
      //   }
      // }, 500)
    // } else {
    //   window.location.href = 'https://account.geekbang.org/infoq/login?redirect=' + encodeURIComponent(redirect)
    // }
  },
  register () {
    window.location.href = 'https://account.geekbang.org/infoq/signup?redirect=' + encodeURIComponent(window.location.href)
  },
  account () {
    window.open('//account.geekbang.org/dashboard/info')
  },
  bindInfoq () {
    window.open('https://account.geekbang.org/infoq/bind?redirect=' + encodeURIComponent(window.location.href))
  },
  search (key = '') {
    window.open(`https://s.geekbang.org/search/c=0/k=${key}/t=`)
  },
  initWxConfig () {
    return new Promise((resolve, reject) => {
      if (!this.isInWeixin()) {
        resolve()
        return
      }

      let url = window.location.href

      ajax({
        type: 'get',
        url: `https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`
      }).then(response => {
        try {
          window.wx.config({
            debug: false,
            appId: response.appId, // 必填，公众号的唯一标识
            timestamp: String(response.timestamp), // 必填，生成签名的时间戳
            nonceStr: response.nonceStr, // 必填，生成签名的随机串
            signature: response.signature, // 必填，签名，见附录1
            jsApiList: ['getLocation', 'openLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'showMenuItems', 'hideMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        } catch (err) {
          console.log(err)
        }
        resolve()
      }).catch(err => {
        console.log(err)
        resolve()
      })
    })
  },
    /**
   * 是否是 PC 环境
   *
   * @return   {boolean} 如果是 PC 环境则返回 true
   */
  isPC: () => {
    var userAgentInfo = navigator.userAgent
    var Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod'
    ]
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  },
  /**
   * 是否是微信浏览器内
   *
   * @return   {boolean} 如果是微信环境则返回 true
   */
  isInWeixin: () => {
    const ua = window.navigator.userAgent
    return !!ua.match(/MicroMessenger/i)
  },
  /**
   * 是否是 iOS 浏览器内
   *
   * @return   {boolean} 如果是 iOS 环境则返回 true
   */
  isIOS: () => {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  /**
   * CDN 的图片处理
   * @see https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1147.3b4d5b80nblRUg
   * @param {Url}     url               图片地址
   * @param {Object}  options           图片配置
   * @param {Object}  options.crop      裁剪图片
   * @param {Number}  options.crop.x    裁剪区的左上角 x 坐标
   * @param {Number}  options.crop.y    裁剪区的左上角 y 坐标
   * @param {Number}  options.crop.w    裁剪区宽度
   * @param {Number}  options.crop.h    裁剪区高度
   * @param {String}  options.crop.g    设置裁剪的原点位置 [nw,north,ne,west,center,east,sw,south,se]
   * @param {Object}  options.resize    缩放图片
   * @param {Number}  options.resize.w  缩放宽度
   * @param {Number}  options.resize.h  缩放高度
   * @param {Number}  options.resize.m  缩放高度
   * @param {Number}  options.resize.l  缩放高度
   * @param {Number}  options.resize.s  缩放高度
   * @param {Number}  options.resize.p  缩放百分比
   */
  image (url, options = {}) {
    const extra = []
    const crop = []
    const resize = []

    // 裁剪参数
    if (options.crop) {
      options.crop.x && crop.push(`x_${options.crop.x}`)
      options.crop.y && crop.push(`y_${options.crop.y}`)
      options.crop.w && crop.push(`w_${options.crop.w}`)
      options.crop.h && crop.push(`h_${options.crop.h}`)
      options.crop.g && crop.push(`g_${options.crop.g}`)

      crop.length && extra.push(`crop,${crop.join(',')}`)
    }

    // 缩放参数
    if (options.resize) {
      options.resize.w && resize.push(`w_${options.resize.w}`)
      options.resize.h && resize.push(`h_${options.resize.h}`)
      options.resize.p && resize.push(`p_${options.resize.p}`)

      resize.length && extra.push(`resize,${resize.join(',')}`)
    }

    const oss = extra.length ? extra.join('/') : ''
    return `${url}${oss ? '?x-oss-process=image/' + oss : ''}`
  },

  /**
   * 给内容中的英文或数字自动增加前后空格
   * a 标签内只是英文时 前后也加空格
   *
   * @param    {string}  text 要自动加空格的内容
   * @return   {string}       处理完空格后的内容
   */
  formatContent (text) {
    if (typeof text !== 'string') return ''
    text = text.replace(/([\u4E00-\u9FA5]|<a.*?>)([a-z0-9@&;=_[$%^*\-+(/])/ig, '$1 $2')
    text = text.replace(/([a-z0-9!~&;=_\],.:?$%^*\-+)/])(<\/a>|[\u4E00-\u9FA5])/ig, '$1 $2')
    return text
  },
  /**
   * 给评论数据里的 链接 加上 a 标签
   */
  formatComment (text) {
    if (typeof text !== 'string') return ''
    const REG = /https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*/ig
    text = text.replace(REG, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener nofollow">${url}</a>`
    })
    return text
  },

  /**
   * 解析指定节点的数学公式
   *
   * @param    {element}  elem 要解析内容中公式的节点
   * @return   void
   */
  handleMathJax: function (elem) {
    if (!document.querySelector('script#MathJax')) {
      let scriptNode = document.createElement('script')
      scriptNode.id = 'MathJax'
      scriptNode.src = '//cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS-MML_HTMLorMML'
      document.getElementsByTagName('head')[0].appendChild(scriptNode)
      scriptNode.onload = event => {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, elem])
      }
    } else {
      window.MathJax && window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, elem])
    }
  },

  /**
   * 分享到微博
   * @param {Url}    url    分享网址
   * @param {String} title  分享标题
   * @param {Url}    image  分享图片
   */
  weiboShare ({url, title, image}) {
    let arr = [
      `url=${encodeURIComponent(url)}`,
      `title=${title}`
    ]

    image && arr.push(`pic=${image}`)

    window.open(`http://service.weibo.com/share/share.php?sharesource=weibo&appkey=577532191&${arr.join('&')}`)
  },
  /**
   * 微信分享
   * @param {Object} opts   分享参数
   * @param {String} title  分享标题
   * @param {String} desc   分享描述
   * @param {String} imgUrl 分享图标
   */
  shareWeixin (opts) {
    if (!this.isInWeixin()) return

    const defaultOption = {
      title: document.title,
      desc: '',
      link: window.location.href,
      success: function () {}
    }
    let option = Object.assign(defaultOption, opts)

    option.imgUrl = option.imgUrl || 'https://static001.geekbang.org/resource/image/03/76/03e51c2c89d95ca05838a9eae6723576.png'
     // 需在用户可能点击分享按钮前就先调用
    window.wx && window.wx.ready(function () {
      window.wx.updateAppMessageShareData(option)

      window.wx.updateTimelineShareData(option)
    })
  },
  /**
   * 倒计时过滤方法
   * @param {Number} timediff 两个时间戳的 时间差
   * @return {String} xx天 xx小时xx分xx秒
   */
  formatTimeDown (timediff, type) {
    if (timediff > 0) {
      let hour = Math.floor(timediff / 1000 / 60 / 60)
      let minute = Math.floor(timediff / 1000 / 60 % 60)
      let second = Math.floor(timediff / 1000 % 60)
      return {
        hour,
        minute,
        second,
        done: false
      }
      // return day > 2 ? `${day} 天 ${hour} : ${minute} : ${second}` : `${hour} : ${minute} : ${second}`
    } else {
      return {
        hour: 0,
        minute: 0,
        second: 0,
        done: true
      }
    }
  },
  /**
   * 格式化数字   小于 10 的时候  前边补位
   * @param {Number} val 输入一个数字
   */
  formatNumber (val) {
    return val < 10 ? `0${val}` : val
  },
  /**
   * 给 url 增加指定的参数，如果 url 中有该参数则替换
   *
   * @param    {string}  url 要加参数的 url
   * @param    {string}  key 要增加的参数名
   * @param    {string}  val 要增加的参数值
   * @return   {string}      处理完的 url
   */
  addUrlParam: (url, key, val) => {
    let newParam = key + '=' + encodeURIComponent(val)
    let params = '?' + newParam
    // If the 'url' string exists, then build params from it
    if (url) {
      // Try to replace an existance instance
      params = url.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam)
      // If nothing was replaced, then add the new param to the end
      if (params === url && url.indexOf(newParam) < 0) {
        params += (url.indexOf('?') > 0 ? '&' : '?') + newParam
      }
    }
    return params
  },
  /**
   * 获取选中节点的文本内容
   *
   * @return  text 选中的文本内容
   */
  getSelectionText: function () {
    var text = ''
    if (typeof window.getSelection !== 'undefined') {
      var sel = window.getSelection()
      if (sel.rangeCount) {
        var container = document.createElement('div')
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents())
        }
        // text = container.innerHTML
        text = container.innerText
      }
    } else if (typeof document.selection !== 'undefined') {
      if (document.selection.type === 'Text') {
        // text = document.selection.createRange().htmlText
        text = document.selection.createRange().text
      }
    }
    return text
  },
  /**
   * 获取字符串的实际长度
   *
   * @return  length 长度
   */
  getLength: function (str) {
    let realLength = 0
    let len = str.length
    let charCode = -1
    for (let index = 0; index < len; index++) {
      charCode = str.charCodeAt(i)
      if (charCode >= 0 && charCode <= 128) realLength += 1
      else realLength += 2
    }
    return realLength
  },
  /**
   * 跳转路由
   * @param {String} path           跳转路由
   * @param {String} target         打开页面方式
   */
  jumpUrl (path, target = '_blank') {
    if (this.isInApp()) {
      Vue.prototype.$timesdk.universalJump(`time://nativeWebView?url=${encodeURIComponent(path)}`)
    }else {
      if (target) {
        window.open(path)
      } else {
        Vue.prototype.$router.push(path)
      }
    }
  },

  /**
   * 是否在微信小程序内
   * [同步方式非异步]
   *
   * @return {boolean} 如果是微信环境则返回 true
   */
  isInWXMiniProgram: () => {
    return (
      (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') || window.navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1
    )
  },

  isInApp () {
    // return Vue.prototype.$timesdk.isInApp()
    return !!navigator.userAgent.match(/org\.geekbang\.(?:GeekTime|enterprise)/i)
  },
    /**
   * infoQ 登陆成功后 通知geekbang 登陆成功
   * safari 中 iframe 会禁用所有的 本地存储功能所以要做兼容处理
   * @param {String} token  user token
   */
  syncGeekbang (token) {
    if (this.isInSafari()) {
      window.location.href = `//account.geekbang.org/syncinfoq/?to=${token}&redirect=${encodeURIComponent(location.href)}`
      return
    }

    return new Promise((resolve, reject) => {
      const iframe = document.createElement('iframe')
      iframe.src = `//account.geekbang.org/syncinfoq/?to=${token}`
      iframe.style.display = 'none'

      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          setTimeout(() => {
            resolve()
          }, 3000)
        })
      } else {
        iframe.onload = function () {
          setTimeout(() => {
            resolve()
          }, 3000)
        }
      }

      // const inInfoQ = location.pathname.indexOf('infoq') !== -1

      window.addEventListener('message', event => {
        if (/\bgeekbang\b\.org$/.test(event.origin)) {
          // event.data === 'logined' && resolve()
          // logger.info('syncInfoQ', {
          //   result: event.data
          // })
          resolve()
        }
      }, {once: true})

      document.body.appendChild(iframe)
    })
  },
  isInSafari () {
    const userAgentInfo = navigator.userAgent.toLowerCase()

    return /safari/.test(userAgentInfo) && !/chrome/.test(userAgentInfo)
  },
  getQueryString: (link, key) => {
    const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
    const queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
    const r = queryString.match(reg)
    if (r !== null) return decodeURIComponent(r[2])
    return ''
  },
  isInInfoQ () {
    return /^\/infoq\/.+/.test(window.location.pathname)
  },
  thirdLogin (type, redirect, params = {}) {
    // 如果禁用了 cookie，直接提示第三方登录功能被禁用
    if (!canUsed) {
      Vue.prototype.$modal.message({
        title: '异常提示',
        message: '登录失败，请确认您的浏览器已打开 cookie 功能后重试。',
        okBtnColor: 'dialogBlue',
        center: state.mobile,
        width: state.mobile ? 300 : 500
      })

      return
    }

    // type: wechat, weibo, qq; redirect: 登录成功后返回原址
    if (type === 'wechat' && this.isInWeixin()) {
      type = params.wechat || 'wechatopen'
    }
    let cbUrl = `https://account.geekbang.org/thirdlogin` // 扫码成功后台回来的地址
    // console.log(redirect)
    // console.log(params)
    // console.log(this.thirdLoginUrl(cbUrl, type, 0, redirect, params))
    window.location.href = this.thirdLoginUrl(cbUrl, type, 0, redirect, params)
    // window.open(this.thirdLoginUrl(cbUrl, type, 0, redirect, params), 'thirdLoginWindow', 'resizable,scrollbars,status,width=800,height=600')
  },
  thirdLoginUrl (url, type, bind, cb, params = {}) {
    // 三方登录跳转地址合成
    // 参数说明
    // 1 url: 微信扫码后回前端的地址  格式 /thirdlogin
    // 2 type: 三方登录类型， wechat, qq, weibo
    // 3 bind: 是绑定账号或者是登录账号 登录为 0 绑定为 1
    // 4 [cb]: 三方登录后返回地址，这个地址是从登录界面传来的。比如从直播过来，正常登录后会返回到直播，如果用户点击三方登录的话同样需要返回来处，这时需要穿这个参数
    let baseUrl = 'https://account.geekbang.org'
    let redirect

    // 三方登录 url 需要额外添加 platform 的参数,以便后续可以收集到注册来源
    const platform = this.isInInfoQ() ? 'infoq' : ''
    type = encodeURIComponent(type)
    bind = encodeURIComponent(bind)

    const regH5Link = /(http|https):\/\/([\w.]+\/?)\S*/
    let URL = regH5Link.test(url) ? url : `${baseUrl}${url}`

    redirect = `${URL}?remember=1&type=${type}&is_bind=${bind}${platform ? '&platform=' + platform : ''}`

    let keys = Object.keys(params)
    if (keys.length > 0) {
      keys.forEach(ele => {
        // redirect += `&${ele}=${params[ele]}`
        redirect = this.addUrlParam(redirect, ele, params[ele])
      })
    }
    if (cb) {
      redirect += `&redirect=${encodeURIComponent(cb)}`
    }
    redirect = encodeURIComponent(redirect)
    let result = `${baseUrl}/account/oauth/authorize?remember=1&type=${type}&is_bind=${bind}&redirect_url=${redirect}`
    return result
  },
  /**
   * 判断两个对象是否相等
   *
   * @param    {object} obj1 对象1
   * @param    {object} obj2 对象2
   * @return   {boolean}   是否相等
   */
  isEqual (obj1, obj2) {
    function isObject (obj) {
      return obj !== null && typeof obj === 'object'
    }
    // 1.两个数据有一个不是对象或数组
    if (!isObject(obj1) || !isObject(obj2)) {
      return obj1 === obj2
    }
    // 2.两个对象是同一个引用
    if (obj1 === obj2) {
      return true
    }

    const obj1Keys = Object.keys(obj1)
    const obj2Keys = Object.keys(obj2)
    // 3.比较obj1和obj2的keys的长度是否相等
    if (obj1Keys.length !== obj2Keys.length) {
      return false
    }
    // 4.通过递归逐一比较，如有由一项不匹配直接返回false
    for (const key in obj1) {
      const res = this.isEqual(obj1[key], obj2[key])
      if (!res) {
        return false
      }
    }
    // 5.全部相等
    return true
  },

  /**
   * 小程序返回上一栈
   */
  mpNavigateBack () {
    wx.miniProgram && wx.miniProgram.navigateBack()
  }
}
